import { armor, invisible } from "./status";
import { dash, leap, teleport } from "./movement";
import { hasAction, registerAction, type ActionHandler } from "./registry";

/** Словарь действий движка. Новое действие — новый файл и одна строка здесь (docs/design/abilities.md). */
const BUILT_IN: Readonly<Record<string, ActionHandler>> = { dash, leap, teleport, invisible, armor };

for (const [type, handler] of Object.entries(BUILT_IN)) if (!hasAction(type)) registerAction(type, handler);

export { hasAction, runAction, registerAction } from "./registry";
export type { ActionContext, ActionHandler } from "./registry";
